import { Injectable }    from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable()
export class ApiService {
    private apiUrl;
    constructor(private http: Http, private router: Router) {
        this.apiUrl = environment.apiUrl;
     }
    getApiUrl(){
        return this.apiUrl;
    }

    /**
     * GET a resource from the API
     * @param endpoint - The endpoint, eg. applications
     * @return Promise<T>
     */
    get(endpoint: string) {
        return new Promise((resolve, reject) => {
            this.http.get(this.apiUrl + endpoint, this.getHeaders()).subscribe((res) => {
                let response = res.json();
                resolve(response);
            }, (err) => {
                this.handleExpiredSession(err, reject);
            });
        });
    }
    /**
     * GET a resource from the API returns csv file
     * @param endpoint - The endpoint, eg. applications
     * @return Promise<T>
     */
    getCsvFormat(endpoint: string) {
        return new Promise((resolve, reject) => {
            let csvHeader:  Headers = new Headers()
            csvHeader.append('x-export-csv', 'true')
            this.http.get(this.apiUrl + endpoint, this.getHeaders(csvHeader)).subscribe((res) => {
                resolve(res);
            }, (err) => {
                this.handleExpiredSession(err, reject);
            });
        });
    }    

    /**
     * PATCH a resource from the API
     * @param endpoint - The endpoint, eg. applications
     * @param body - The to send, eg. {firstName: 'Winter'}
     * @return Promise<T>
     */
    patch(endpoint: string, body: any = {}) {
        return new Promise((resolve, reject) => {
            this.http.patch(this.apiUrl + endpoint, body, this.getHeaders()).subscribe((res) => {
                let response = res.json();
                resolve(response);
            }, (err) => {
                this.handleExpiredSession(err, reject);
            })
        });
    }

    /**
     * POST a resource from the API
     * @param endpoint - The endpoint, eg. applications
     * @param body - The to send, eg. {firstName: 'Winter'}
     * @return Promise<T>
     */
    post(endpoint: string, body: any = {}) {
        return new Promise((resolve, reject) => {
            this.http.post(this.apiUrl + endpoint, body, this.getHeaders()).subscribe((res) => {
                let response = res.json();
                resolve(response);
            }, (err) => {
                this.handleExpiredSession(err, reject);
            })
        });
    }
    /**
     * POST a resource from the API
     * @param endpoint - The endpoint, eg. applications
     * @param body - The to send, eg. {firstName: 'Winter'}
     * @return Promise<T>
     */
    delete(endpoint: string, body: any = {}) {
        return new Promise((resolve, reject) => {
            this.http.delete(this.apiUrl + endpoint,this.getHeaders()).subscribe((res) => {
                let response = res.json();
                resolve(response);
            }, (err) => {
                this.handleExpiredSession(err, reject);
            })
        });
    }

    getHeaders(headers : Headers = new Headers()) {
        headers.append('Authorization', localStorage.getItem('token'));

        return new RequestOptions({ headers: headers });
    }

    authenticate(data: any) {
         return new Promise((resolve, reject) => {
             this.http.post(this.apiUrl + 'authentication', data).subscribe((res) => {
                 let response = res.json();

                 // Save token in localStorage
                 localStorage.setItem("token", response.accessToken);

                 // Save email address in localStorage
                 localStorage.setItem("email", data.email);

                 resolve(response.data);
             }, (err) => {
                 reject(err);
             });
         });
     }


     isAuthenticated() {
         return new Promise((resolve, reject) => {
             let accessToken = localStorage.getItem('token');

             if(accessToken !== null) {
                 this.post('authentication').then((res) => {
                     resolve(true);
                 }).catch((err) => {
                     reject(err);
                 });
             } else {
                 reject('No token found');
             }
         });
     }

     handleExpiredSession(err, reject) {
         if(err.status == 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("email");
            localStorage.setItem('sessionExpired', 'true');
            this.router.navigateByUrl('login');
         }

         reject(err);
     }

}



// WEBPACK FOOTER //
// ./src/app/services/api.service.ts